import { Promo } from "../models/promo";

// The year a promo "belongs to", for the Excel export picker on the home page.
// The backend has no year filter, so the client groups by itself:
//  1. `active_from_date` ("yyyy-MM-dd") — the start of the project, the
//     meaningful year; optional in the backend, so it can be empty;
//  2. fallback: `created_at` ("dd/MM/yyyy HH:mm") — always filled, but a
//     project created in December for January lands a year early.
// The code itself (e.g. 0126JAN = MMYY) is deliberately NOT used: not every
// code follows that pattern (2506XANDER).
export function promoYear(promo: Promo): number | null {
  const from = promo.active_from_date?.match(/^(\d{4})-\d{2}-\d{2}/);
  if (from) return Number(from[1]);
  const created = promo.created_at?.match(/^\d{2}\/\d{2}\/(\d{4})/);
  if (created) return Number(created[1]);
  return null;
}

// Sortable "yyyy-MM-dd" for newest-first ordering within a year, same
// source order as promoYear. "" when unknown (sorts last).
export function promoSortDate(promo: Promo): string {
  if (promo.active_from_date?.match(/^\d{4}-\d{2}-\d{2}/))
    return promo.active_from_date.slice(0, 10);
  const created = promo.created_at?.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (created) return `${created[3]}-${created[2]}-${created[1]}`;
  return "";
}
